/**
 * Campo di scrittura: cresce con il testo, Invio manda, Maiusc+Invio va a capo.
 * Durante la risposta il bottone diventa «Interrompi».
 */

import { forwardRef, useEffect, useRef, useState, type KeyboardEvent } from "react";
import { IconaInvia, IconaStop } from "./icone";

interface Proprieta {
  occupato: boolean;
  disabilitato: boolean;
  onInvia: (testo: string) => void;
  onInterrompi: () => void;
}

export const LIMITE_CARATTERI = 2000;
const ALTEZZA_MASSIMA = 132;

export const Input = forwardRef<HTMLTextAreaElement, Proprieta>(function Input(
  { occupato, disabilitato, onInvia, onInterrompi },
  ref,
) {
  const [testo, setTesto] = useState("");
  const interno = useRef<HTMLTextAreaElement | null>(null);

  const collega = (el: HTMLTextAreaElement | null) => {
    interno.current = el;
    if (typeof ref === "function") ref(el);
    else if (ref) ref.current = el;
  };

  useEffect(() => {
    const el = interno.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, ALTEZZA_MASSIMA)}px`;
  }, [testo]);

  const invia = () => {
    const pulito = testo.trim();
    if (!pulito || occupato || disabilitato) return;
    onInvia(pulito);
    setTesto("");
  };

  const suTasto = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      invia();
    }
  };

  return (
    <div className="assistente__input">
      <div className="assistente__campo">
        <textarea
          ref={collega}
          rows={1}
          value={testo}
          maxLength={LIMITE_CARATTERI}
          disabled={disabilitato}
          placeholder="Scrivi una domanda…"
          aria-label="La tua domanda"
          onChange={(e) => setTesto(e.target.value)}
          onKeyDown={suTasto}
        />
        {occupato ? (
          <button type="button" className="assistente__invia" onClick={onInterrompi} aria-label="Interrompi la risposta">
            <IconaStop dimensione={18} />
          </button>
        ) : (
          <button
            type="button"
            className="assistente__invia"
            onClick={invia}
            disabled={disabilitato || !testo.trim()}
            aria-label="Invia la domanda"
          >
            <IconaInvia dimensione={18} />
          </button>
        )}
      </div>
      <p className="assistente__nota">L'assistente può sbagliare: verifica sulle fonti ufficiali.</p>
    </div>
  );
});
